import { z } from 'zod';
import { dateParser, enumParser, FilespaceAccessSourceType, serviceAccountMemberRoleParser, UNKNOWN_ENUM_VALUE, } from '#validation';
import { memberRefSchema } from '#web-service-api/member';
const handledFilespaceAccessSourceTypeParser = enumParser(FilespaceAccessSourceType);
const filespaceAccessSourceUnionSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal(FilespaceAccessSourceType.DIRECT) }),
    z.looseObject({ type: z.literal(UNKNOWN_ENUM_VALUE) }),
]);
/** A source type unknown to this client is kept as `$unknown` so newer WebService responses still parse. */
export const filespaceAccessSourceSchema = z.preprocess((input) => {
    const result = z
        .looseObject({ type: handledFilespaceAccessSourceTypeParser })
        .safeParse(input);
    return result.success ? result.data : input;
}, filespaceAccessSourceUnionSchema);
export const filespaceAccessSchema = z.object({
    filespaceId: z.string(),
    sources: z.array(filespaceAccessSourceSchema),
});
export const BaseServiceAccountResponseSchema = z.object({
    id: z.string(),
    accountId: z.string(),
    name: z.string(),
    member: z.object({
        role: serviceAccountMemberRoleParser,
    }),
    createdAt: dateParser(),
    createdByMemberId: z.string(),
    createdByMember: memberRefSchema.nullish(),
    workspaceId: z.string(),
    /** Present only when requested with `includeFilespaceAccess=true`. */
    filespaceAccess: z.array(filespaceAccessSchema).optional(),
});
